import React from 'react';
import classnames from 'classnames';

import ubBanzai from 'ub/control/banzai-features';

export default function PageMobileTour() {
  const isNewBreakpointToggleEnabled = ubBanzai.features.isNewBreakpointToggleEnabled();
  const step1ImageClassName = classnames('mobile-tour-img', {new: isNewBreakpointToggleEnabled});

  return (
    <section className='overlay-slides'>
      <div className='nav-dots'>
        <div className='dot active' />
        <div className='dot' />
        <div className='dot' />
        <div className='dot' />
      </div>
      <section className='overlay-slide in'>
        <div className='right-col step-1'>
          <div className={step1ImageClassName} />
        </div>
        <span className='left-col'>
          <span className='slide-header'>
            Show the mobile version to your visitors
          </span>
          {
            isNewBreakpointToggleEnabled ? (
              <span className='slide-content'>
                When you’re ready for mobile visitors to see the mobile version of your page,
                enable the <strong>Mobile</strong> toggle in the bottom-right. Then publish
                (or republish) your page.
              </span>
            ) : (
              <span className='slide-content'>
                When you’re ready for mobile visitors to
                see the mobile version of your Page select
                <strong> &lsquo;Show Mobile Version to Visitors&rsquo; </strong>
                from your Page Properties tab on the right. Then publish (or
                republish) your Page.
              </span>
            )
          }
          <span className='slide-content' />
        </span>
      </section>
      <section className='overlay-slide'>
        <div className='right-col step-2'>
          <div className='mobile-tour-img' />
        </div>
        <span className='left-col'>
          <span className='slide-header'>Scale the text in your mobile version</span>
          <span className='slide-content'>
            Use the scale corners to resize the
            text in your mobile page.
          </span>
        </span>
      </section>
      <section className='overlay-slide'>
        <div className='right-col step-3'>
          <div className='mobile-tour-img' />
        </div>
        <span className='left-col'>
          <span className='slide-header'>
            Toggle the visibility of your page&apos;s contents
          </span>
          <span className='slide-content'>
            Click the eye in your <strong>&lsquo;Page Contents&rsquo;</strong> pane
            to toggle the visibility of any object
            on your page for either mobile or desktop.
          </span>
        </span>
      </section>
      <section className='overlay-slide'>
        <div className='right-col step-4'>
          <div className='mobile-tour-img' />
        </div>
        <span className='left-col'>
          <span className='slide-header'>Want to learn more about responsive?</span>
          <span className='slide-content'>
            Check out these
            <a
              href='http://documentation.unbounce.com/hc/en-us/articles/203788184#content2'
              target='_blank'
              rel="noopener noreferrer"
            >
              support articles
            </a>
            on getting the most out of mobile responsive for your campaigns.
          </span>
        </span>
      </section>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/mobile-tour/page-mobile-tour.jsx